import { call, takeLatest, put, } from 'redux-saga/effects';
import {getonboardingbusinessInfoSuccess, getonboardingbusinessInfoRequest, getonboardingbusinessInfoFailure } from '../../actions/adminFlow/businessInfoAction';
import {onboardingBusinessInfo} from '../../../api/Admin/adminflowAPI';

function* onboardingBusinessInfoSaga(action) {
	try {
		const response = yield call(onboardingBusinessInfo, action);
		yield put(getonboardingbusinessInfoSuccess(response));
	  } catch (e) {
		yield put(getonboardingbusinessInfoFailure(e.response?.data));
	  }
}

function* onboardingBusinessDetailsSaga() {
	yield takeLatest(getonboardingbusinessInfoRequest, onboardingBusinessInfoSaga);
	
}

export default onboardingBusinessDetailsSaga;
